(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-arrivals-hero__section"]) return;
  try {
    
  $(function () {
    slick_slider();
  });

  // To run slick slider properly in Theme Customizer
  $(document).on("shopify:section:load", function () {
    slick_slider();
  });

  // To run slick slider properly in Theme Customizer
  $(document).on("shopify:section:unload", function () {
    slick_slider();
  });

  // To run slick slider properly in Theme Customizer
  $(document).on("shopify:section:select", function () {
    slick_slider();
  });

  // To run slick slider properly in Theme Customizer
  $(document).on("shopify:section:deselect", function () {
    slick_slider();
  });

  function slick_slider() {
    $(document).ready(function(){
      var total = $('.home-slider .my-slide').length,
    rand = Math.floor( Math.random() * total ); // random number

    $('.home-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        slide: ".my-slide",
        pauseOnHover:false,
        cssEase: 'linear',
      });
  $('.home-slider').slick('slickGoTo', rand);

  });
  }

  // To Run slick slider autoplay properly in both theme customizer as well as in site or preview
  slick_slider();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-styles__section"]) return;
  try {
    
  $(function () {
      slick_slider2();
    });

    // To run slick slider properly in Theme Customizer
    $(document).on("shopify:section:load", function () {
      slick_slider2();
    });

    // To run slick slider properly in Theme Customizer
    $(document).on("shopify:section:unload", function () {
      slick_slider2();
    });

    // To run slick slider properly in Theme Customizer
    $(document).on("shopify:section:select", function () {
      slick_slider2();
    });

    // To run slick slider properly in Theme Customizer
    $(document).on("shopify:section:deselect", function () {
      slick_slider2();
    });

    function slick_slider2() {
     $(document).ready(function(){
      $('.new-style-slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow:"<button type='button' class='slick-prev slick-arrow'><svg class='flickity-button-icon' viewBox='0 0 100 100'><path d='M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z' class='arrow'></path></svg></button>",
        nextArrow:"<button type='button' class='slick-next slick-arrow'><svg class='flickity-button-icon' viewBox='0 0 100 100'><path d='M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z' class='arrow' transform='translate(100, 100) rotate(180) '></path></svg></button>",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              arrows: false,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '30%',
              arrows: false,
            }
          },
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '30%',
              arrows: false,
            }
          }
        ] // Added a closing curly brace here
      });
    });
    }

    // To Run slick slider autoplay properly in both theme customizer as well as in site or preview
    slick_slider2();

  } catch(e) { console.error(e); }
})();
})();
